import classNames from 'classnames'
import { message } from 'antd'
import React, { useState, useRef, useEffect, useCallback } from 'react'
import ReactDOM from 'react-dom'
import moment from 'moment'
import Icon from 'meinian-package/src/component/icon'
import request from 'meinian-package/src/utils/request'
import util from 'meinian-package/src/utils/util'
import Tooltip from 'meinian-package/src/baseComponent/tooltip'
import { Loading } from 'meinian-package/src/baseComponent'
import './index.less'

let visible = false
let timer = null
let listTimer = null
function DownloadCenter(props) {
  const { className, id, style } = props

  useEffect(() => {
    heartBeat()
    return () => {
      clearInterval(timer)
    }
  }, [])

  const fetchSuccessData = async () => {
    const res = await request.get('/zhikuan/export/task/check-complete', { ignoreError: true })
    if (res?.length && !visible) {
      DownloadCenter.success({ data: res })
    }
  }
  const heartBeat = () => {
    fetchSuccessData()
    timer = setInterval(() => { fetchSuccessData() }, 30 * 1000)
  }

  return <div
    className={classNames('mn-download-center icon-button-wrap', className)}
    style={style}
    id={id || 'mnDownloadCenterDeno'}
    onClick={() => {
      util.track('mn-header-link', {
        module1: '顶部导航',
        module2: '数据导出',
      })
      !visible && DownloadCenter.list()
    }}
  >
    <Tooltip title="数据导出">
      <Icon type="m-shujudaochu" />
    </Tooltip>
  </div>
}

export default DownloadCenter

function Start(props) {
  const { container, centerId, type } = props

  const $list = useRef()
  useEffect(() => {
    const $trigger = document.querySelector(centerId || '#mnDownloadCenterDeno')
    const { top, left } = $trigger.getBoundingClientRect()
    if (top <= 0) {
      $list.current.style.top = '55px'
      $list.current.style.right = '24px'
    } else {
      $list.current.style.top = `${top + 45}px`
      $list.current.style.left = `${left - 360 + $trigger.clientWidth}px`
    }

    setTimeout(() => { close() }, 5000)
  }, [])

  const close = () => {
    const unmountResult = ReactDOM.unmountComponentAtNode(container)
    if (unmountResult && container.parentNode) {
      container.parentNode.removeChild(container)
    }
  }

  return ReactDOM.createPortal(
    <div
      ref={$list}
      className="mn-download-center-start"
      onClick={(e) => {
        e.stopPropagation()
        close()
        DownloadCenter.list()
      }}
    >
      <Icon type="m-xinxi_tianchong" className="download-center-icon warning" />{type === 0 ? '数据表格正在生成，点击此处可查看进度，完成后可在此直接下载' : '图片正在打包中，点击此处可查看进度完成后可在此直接下载'}
    </div>,
    document.body
  )
}

// 1=初始化 2=任务成功 3=已通知用户 4=任务失败
const STATUS = { START: '1', SUCCESS: '2', NOTICED: '3', FAILED: '4' }
function List(props) {
  const { centerId, container } = props
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const $list = useRef()

  const handResize = useCallback(() => {
    const $trigger = document.querySelector(centerId || '#mnDownloadCenterDeno')
    const { top, left } = $trigger.getBoundingClientRect()
    if (top <= 0) {
      $list.current.style.top = '55px'
      $list.current.style.right = '24px'
    } else {
      $list.current.style.top = `${top + 48}px`
      $list.current.style.left = `${left - 360 + $trigger.clientWidth}px`
    }
  })

  useEffect(() => {
    const $trigger = document.querySelector('#mnDownloadCenterDeno')
    const onClick = (e) => {
      if (!$trigger?.contains?.(e.target)) {
        onClose()
      }
    }
    window.addEventListener('click', onClick)
    return () => {
      clearTimer()
      window.removeEventListener('click', onClick)
    }
  }, [])

  const handScroll = useCallback(() => {
    onClose()
  })
  useEffect(() => {
    fetchData(true)
    heartBeat()
    handResize()
    window.addEventListener('resize', handResize)
    window.addEventListener('scroll', handScroll)
    return () => {
      clearTimeout(listTimer)
      window.removeEventListener('resize', handResize)
      window.removeEventListener('scroll', handScroll)
    }
  }, [])

  const heartBeat = () => {
    listTimer = setInterval(() => { fetchData() }, 5 * 1000)
  }

  const fetchData = async (hasloading) => {
    hasloading && setLoading(true)
    try {
      const res = await request.get('/zhikuan/export/task/list-tasks')
      setData(res)
      hasloading && setLoading(false)
    } catch (err) {
      console.error(err)
    }
  }

  const onDelete = async (taskId) => {
    try {
      await request.post('/zhikuan/export/task/delete', { taskId })
      setData(pre => pre.filter(m => m.taskId !== taskId))
      message.success('删除成功')
    } catch (err) {
      console.error(err)
    }
  }

  const onRestart = async (taskId) => {
    try {
      await request.post('/zhikuan/export/task/restart', { taskId })
      fetchData()
    } catch (err) {
      console.error(err)
    }
  }

  const getExtraTime = (finishedAt) => {
    return moment().diff(moment(finishedAt), 'hours')
  }

  const onClose = () => {
    const $trigger = document.querySelector('#mnDownloadCenterDeno')
    if ($trigger) {
      $trigger.className = 'mn-download-center'
    }
    clearTimer()
    clearTimeout(listTimer)
    ReactDOM.unmountComponentAtNode(container)
  }

  const clearTimer = () => {
    timer && clearInterval(timer)
    visible = false
  }

  return ReactDOM.createPortal(
    <div
      ref={$list}
      className="mn-download-center-list-wrap"
      onClick={(e) => {
        e.stopPropagation()
      }}
    >
      <div className="list-title">数据导出列表</div>
      {loading ? <Loading loading={loading} style={{ height: 64 }} />
        : data.length ? <ul className="download-center-list-ul">
          {data.map(item => {
            if (item.status === STATUS.START) {
              return <li key={item.taskId}>
                <Icon type={item.exportType === 1 ? 'm-baobiao' : 'm-tupiandabao'} className={`icon ${item.exportType === 1 ? 'mnbaobiao' : 'mntupiandabao'}`} />
                <div>
                  <span className="name">{item.fileName}</span>
                  <div className="status">正在生成...</div>
                  <div className="doing" />
                </div>
              </li>
            }
            if (item.status === STATUS.FAILED) {
              return <li key={item.taskId}>
                <Icon type={item.exportType === 1 ? 'm-baobiao' : 'm-tupiandabao'} className={`icon ${item.exportType === 1 ? 'mnbaobiao' : 'mntupiandabao'}`} />
                <div>
                  <span className="name failed">{item.fileName}</span>
                  <div className="status failed">生成失败，请重试</div>
                </div>
                <div style={{ flex: 1 }} />
                <button type="button" className="action-icon" onClick={() => onRestart(item.taskId)}>
                  <Tooltip title="重试">
                    <Icon type="m-shuaxin" />
                  </Tooltip>
                </button>
                <button type="button" className="action-icon delete" onClick={() => onDelete(item.taskId)}>
                  <Tooltip title="删除">
                    <Icon type="m-shanchu" />
                  </Tooltip>
                </button>
              </li>
            }
            return <li key={item.taskId}>
              <Icon type={item.exportType === 1 ? 'm-baobiao' : 'm-tupiandabao'} className={`icon ${item.exportType === 1 ? 'm-baobiao' : 'm-tupiandabao'}`} />
              <div>
                <span className="name">{item.fileName} <Icon type="m-chenggong" style={{ color: 'var(--m-success-normal)', fontSize: '14px' }} /></span>
                <div className="status success">已完成，可下载，{getExtraTime(item.finishedAt) > 47 ? '即将' : `${48 - getExtraTime(item.finishedAt)}小时后`}过期</div>
              </div>
              <div style={{ flex: 1 }} />
              <a className="action-icon" href={item.resultUrl}>
                <Tooltip title="下载">
                  <Icon type="m-xiazai" />
                </Tooltip>
              </a>
              <button type="button" className="action-icon delete" onClick={() => onDelete(item.taskId)}>
                <Tooltip title="删除">
                  <Icon type="m-shanchu" />
                </Tooltip>
              </button>
            </li>
          })}
        </ul> : <div className="empty">暂无数据导出或图片打包记录</div>}
      <div className="tip"><Icon type="m-xinxi_tianchong" className="download-center-icon warning" />数据和导出内容仅保留48小时，过期后自动清除</div>
    </div>,
    document.body
  )
}

function Success(props) {
  const { container, centerId, data = [] } = props
  const $list = useRef()

  useEffect(() => {
    const $trigger = document.querySelector(centerId || '#mnDownloadCenterDeno')
    const { top, left } = $trigger.getBoundingClientRect()
    if (top <= 0) {
      $list.current.style.top = '55px'
      $list.current.style.right = '24px'
    } else {
      $list.current.style.top = `${top + 45}px`
      $list.current.style.left = `${left - 360 + $trigger.clientWidth}px`
    }
    setTimeout(() => { close() }, 5000)
  }, [])

  const close = (index) => {
    if (index) {
      for (const node of $list.current.children) {
        if (node.getAttribute('data-index') === index) {
          $list.current.removeChild(node)
        }
      }
    } else {
      const unmountResult = ReactDOM.unmountComponentAtNode(container)
      if (unmountResult && container.parentNode) {
        container.parentNode.removeChild(container)
      }
    }
  }

  return ReactDOM.createPortal(
    <ul
      ref={$list}
      className="mn-download-center-success"
      onClick={(e) => {
        e.stopPropagation()
      }}
    >
      {data.slice(0, 5).map((item, index) => <li data-index={index} key={item.taskId}><Icon type="m-xiaoyan_tianchong" className="download-center-icon success" /><div style={{ flex: 1 }}>{item.fileName}已生成，<a href={item.resultUrl} onClick={() => close(index.toString())}>点此下载</a></div></li>)}
    </ul>,
    document.body
  )
}

DownloadCenter.start = (props) => {
  const $start = document.createElement('div')
  return new Promise(() => {
    ReactDOM.render(<Start {...props} container={$start} />, $start)
  })
}

DownloadCenter.list = (props) => {
  visible = true
  const $trigger = document.querySelector('#mnDownloadCenterDeno')
  const $list = document.createElement('div')
  if ($trigger) {
    $trigger.className = 'mn-download-center active'
  }
  return new Promise(() => {
    ReactDOM.render(<List {...props} container={$list} />, $list)
  })
}

DownloadCenter.success = (props) => {
  if (visible) return
  const $success = document.createElement('div')
  return new Promise(() => {
    ReactDOM.render(<Success {...props} container={$success} />, $success)
  })
}
